import { render, staticRenderFns } from "./simOpenLe.vue?vue&type=template&id=b8ffedf2&scoped=true&"
import script from "./simOpenLe.vue?vue&type=script&lang=js&"
export * from "./simOpenLe.vue?vue&type=script&lang=js&"
import style0 from "./simOpenLe.vue?vue&type=style&index=0&id=b8ffedf2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8ffedf2",
  null
  
)

export default component.exports